module.exports = __webpack_public_path__ + "img/grey-academy-product.c554263d.png";